import React from "react";
import { RentLinkedAccountsCreateCardScreenContainer } from "src/containers";

export const RentLinkedAccountsCreateCardScreen = () => {
  return <RentLinkedAccountsCreateCardScreenContainer />;
};
